import * as XLSX from "xlsx";

export function groupToArrayBySampleId(results, options = {}) {
    const { sortSamples = true, sortRowsBy } = options;

    const map = results.reduce((acc, item) => {
        const key = item.sample_id || "UNKNOWN";
        if (!acc.has(key)) acc.set(key, []);
        acc.get(key).push(item);
        return acc;
    }, new Map());

    let groupedArray = Array.from(map.entries()).map(([sample_id, rows]) => {
        let finalRows = rows;

        // ordenar filas dentro de cada sample (opcional)
        if (typeof sortRowsBy === "function") {
            finalRows = [...rows].sort(sortRowsBy);
        }

        return { sample_id, rows: finalRows };
    });

    // ordenar samples (opcional)
    if (sortSamples) {
        groupedArray = groupedArray.sort((a, b) =>
            String(a.sample_id).localeCompare(String(b.sample_id))
        );
    }

    return groupedArray;
}


export async function convertToCSV(file) {
    const name = file.name.toLowerCase();

    const readText = () =>
        new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsText(file);
        });

    // CSV
    if (name.endsWith(".csv")) {
        return await readText();
    }

    // TSV
    if (name.endsWith(".tsv")) {
        const text = await readText();
        return text.replace(/\t/g, ",");
    }

    // TXT
    if (name.endsWith(".txt")) {
        return await readText();
    }

    // XLS / XLSX
    if (name.endsWith(".xls") || name.endsWith(".xlsx")) {
        const data = await file.arrayBuffer();

        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const csv = XLSX.utils.sheet_to_csv(worksheet);

        return csv;
    }

    throw new Error("Unsupported file format");
}


export function downloadCSV(csvContent, fileName = "metadata.csv") {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.setAttribute("download", fileName);

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export async function convertToCSVFile(file) {
    const name = file.name.toLowerCase();

    const readText = () =>
        new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsText(file);
        });

    let csvContent = "";

    // CSV
    if (name.endsWith(".csv")) {
        csvContent = await readText();
    }

    // TSV
    else if (name.endsWith(".tsv")) {
        const text = await readText();
        csvContent = text.replace(/\t/g, ",");
    }

    // TXT
    else if (name.endsWith(".txt")) {
        csvContent = await readText();
    }

    // XLS / XLSX
    else if (name.endsWith(".xls") || name.endsWith(".xlsx")) {
        const data = await file.arrayBuffer();
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        csvContent = XLSX.utils.sheet_to_csv(worksheet);
    }

    else {
        throw new Error("Unsupported file format");
    }

    // obtener nombre sin extensión
    const baseName = file.name.replace(/\.[^/.]+$/, "");

    // crear archivo CSV nuevo
    const csvFile = new File(
        [csvContent],
        `${baseName}.csv`,
        { type: "text/csv" }
    );

    return csvFile;
}